import { GenericAbortSignal } from 'axios';

import { DenialListItem, Sex } from 'models/DenialListItem';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type DenialListItemsIndexParams = BaseIndexQueryParams;

// The five writable fields, shared by create and update and kept symmetric with the API
// permitted params and the CSV upload columns.
export type DenialListItemMutationParams = {
  patientName: string;
  dateOfBirth: string;
  sex: Sex;
  reason: string | null;
  dateAdded: string | null;
};

export const denialListItemQueryKeys = {
  base: ['denialListItems'],
  index: (params: Record<string, any> = {}) => ['denialListItems', 'index', params],
};

export async function indexDenialListItems(params: DenialListItemsIndexParams, signal: GenericAbortSignal) {
  return http
    .get<Paginated<DenialListItem>>('/denial_list_items', { params, signal })
    .then((response) => response.data);
}

export async function createDenialListItem(params: DenialListItemMutationParams) {
  return http.post<DenialListItem>('/denial_list_items', params).then((response) => response.data);
}

export async function updateDenialListItem({ id, ...params }: DenialListItemMutationParams & { id: string }) {
  return http.patch<DenialListItem>(`/denial_list_items/${id}`, params).then((response) => response.data);
}

export async function destroyDenialListItem({ id }: { id: string }) {
  return http.delete(`/denial_list_items/${id}`);
}
